import { Box } from '@workos-inc/design-system';
import Head from 'next/head';
import { Header } from 'src/components/header';
import { JwtDebugger } from 'src/components/jwt-debugger/jwt-debugger';
import { NavigationWrapper } from 'src/components/navigation-wrapper';
import { PageBackground } from 'src/components/page-background';
import { PageLayout } from 'src/components/page-layout';
const JwtDebuggerPage = () => {
  const title = 'JWT Debugger — WorkOS';
  const description = 'Decode, inspect, and verify JSON Web Tokens. Paste a JWT to see its header, payload, and verify HMAC-SHA256 signatures.';
  return <Box position="relative" data-sentry-element="Box" data-sentry-component="JwtDebuggerPage" data-sentry-source-file="jwt-debugger.tsx">
      <Head data-sentry-element="Head" data-sentry-source-file="jwt-debugger.tsx">
        <title>{title}</title>
        <meta content={description} name="description" data-sentry-element="meta" data-sentry-source-file="jwt-debugger.tsx" />
        <meta content={description} name="og:description" data-sentry-element="meta" data-sentry-source-file="jwt-debugger.tsx" />
        <meta content={title} property="og:title" data-sentry-element="meta" data-sentry-source-file="jwt-debugger.tsx" />
        <meta content="website" property="og:type" data-sentry-element="meta" data-sentry-source-file="jwt-debugger.tsx" />
      </Head>

      <PageBackground data-sentry-element="PageBackground" data-sentry-source-file="jwt-debugger.tsx" />

      <Header caption="Tools" data-sentry-element="Header" data-sentry-source-file="jwt-debugger.tsx" />

      <PageLayout.Root layout="index" data-sentry-element="PageLayout.Root" data-sentry-source-file="jwt-debugger.tsx">
        <PageLayout.Nav data-sentry-element="PageLayout.Nav" data-sentry-source-file="jwt-debugger.tsx">
          <NavigationWrapper data-sentry-element="NavigationWrapper" data-sentry-source-file="jwt-debugger.tsx" />
        </PageLayout.Nav>

        <PageLayout.Content data-sentry-element="PageLayout.Content" data-sentry-source-file="jwt-debugger.tsx">
          <JwtDebugger data-sentry-element="JwtDebugger" data-sentry-source-file="jwt-debugger.tsx" />
        </PageLayout.Content>
      </PageLayout.Root>
    </Box>;
};
export default JwtDebuggerPage;